import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0043d56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center justify-content-between w-100 pe-8" }
const _hoisted_2 = { class: "fw-bold fs-4" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "d-flex flex-column gap-6" }
const _hoisted_6 = { class: "card card-flush border" }
const _hoisted_7 = { class: "card-header min-h-50px" }
const _hoisted_8 = { class: "card-title fw-bold" }
const _hoisted_9 = { class: "card-body pt-2" }
const _hoisted_10 = { class: "d-flex align-items-center gap-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-5" }, "-", -1))
const _hoisted_12 = { class: "card card-flush border" }
const _hoisted_13 = { class: "card-header min-h-50px" }
const _hoisted_14 = { class: "card-title fw-bold" }
const _hoisted_15 = { class: "card-body pt-2" }
const _hoisted_16 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_17 = { class: "text-muted" }
const _hoisted_18 = { class: "card card-flush border" }
const _hoisted_19 = { class: "card-header min-h-50px" }
const _hoisted_20 = { class: "card-title fw-bold" }
const _hoisted_21 = { class: "card-body pt-2" }
const _hoisted_22 = {
  key: 0,
  class: "d-flex flex-column gap-3"
}
const _hoisted_23 = { class: "fw-semibold d-flex align-items-center gap-2" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/icons/arrows/arr080.svg",
  alt: "->",
  style: {"width":"22px","height":"22px"}
}, null, -1))
const _hoisted_25 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_26 = { class: "card card-flush border" }
const _hoisted_27 = { class: "card-header min-h-50px" }
const _hoisted_28 = { class: "card-title fw-bold" }
const _hoisted_29 = { class: "card-body pt-2 d-flex flex-column gap-4" }
const _hoisted_30 = { class: "fw-bold mb-2" }
const _hoisted_31 = { class: "d-flex flex-column gap-3" }
const _hoisted_32 = { class: "d-flex align-items-center gap-4" }
const _hoisted_33 = { class: "d-flex align-items-center gap-2" }
const _hoisted_34 = { class: "text-muted" }
const _hoisted_35 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_36 = { class: "d-flex justify-content-end gap-3" }

import { computed, ref } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { CurrencyTypes } from "@/core/types/CurrencyTypes";
import PaymentService, {
  AutoCompleteTransferConfig,
  AutoCompleteTransferConfigValue,
} from "../../services/PaymentService";
import i18n from "@/core/plugins/i18n";

const DEFAULT_KEY = "AutoCompleteAndTransferCurrencyAvailable";


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoTransferOptions',
  setup(__props, { expose: __expose }) {

const DIALOG_TITLE = i18n.global.t("autoTransfer.title");
const dialogRef = ref(false);
const isLoading = ref(false);

const formData = ref<AutoCompleteTransferConfig>({
  key: DEFAULT_KEY,
  name: "AutoCompleteTransactionAmountFo",
  description: "used for trade account auto transfer as of now",
  dataFormat: "json",
  value: {
    enabled: false,
    currencyTransferUnAvailableStartTime: "00:00",
    currencyTransferUnAvailableEndTime: "00:00",
    allowCurrencyBetween: {},
    allowCurrencyTransfer: {},
    autoCompleteOverMarginCheck: false,
  },
});

const allowCurrencyBetweenEntries = computed(() => {
  return Object.entries(formData.value.value.allowCurrencyBetween || {}).map(
    ([key, enabled]) => {
      const [fromId, toId] = key.split("_");
      return {
        key,
        enabled,
        fromId,
        toId,
      };
    }
  );
});

const allowCurrencyTransferEntries = computed(() => {
  return Object.entries(formData.value.value.allowCurrencyTransfer || {}).map(
    ([currencyId, rules]) => ({
      currencyId,
      rules,
    })
  );
});

const normalizeValue = (value: any): AutoCompleteTransferConfigValue => {
  const enabled = value?.enabled ?? value?.Enabled ?? false;
  const currencyTransferUnAvailableStartTime =
    value?.currencyTransferUnAvailableStartTime ??
    value?.CurrencyTransferUnAvailableStartTime ??
    "00:00";
  const currencyTransferUnAvailableEndTime =
    value?.currencyTransferUnAvailableEndTime ??
    value?.CurrencyTransferUnAvailableEndTime ??
    "00:00";
  const allowCurrencyBetween =
    value?.allowCurrencyBetween ?? value?.AllowCurrencyBetween ?? {};
  const allowCurrencyTransfer =
    value?.allowCurrencyTransfer ?? value?.AllowCurrencyTransfer ?? {};
  const autoCompleteOverMarginCheck =
    value?.autoCompleteOverMarginCheck ??
    value?.AutoCompleteOverMarginCheck ??
    false;

  const normalizedTransfer = Object.fromEntries(
    Object.entries(allowCurrencyTransfer).map(
      ([currencyId, rules]: [string, any]) => {
        const normalizedRules = (rules || []).map((rule) => ({
          enabled: rule?.enabled ?? rule?.Enabled ?? false,
          type: rule?.type ?? rule?.Type ?? "",
          // API stores amounts in cents; convert to major units for display
          amount: Number(rule?.amount ?? rule?.Amount ?? 0) / 100,
        }));
        return [currencyId, normalizedRules];
      }
    )
  );

  return {
    enabled: Boolean(enabled),
    currencyTransferUnAvailableStartTime,
    currencyTransferUnAvailableEndTime,
    allowCurrencyBetween,
    allowCurrencyTransfer: normalizedTransfer,
    autoCompleteOverMarginCheck: Boolean(autoCompleteOverMarginCheck),
  };
};

const normalizeConfig = (data: any): AutoCompleteTransferConfig => {
  return {
    ...data,
    key: data?.key ?? DEFAULT_KEY,
    name: data?.name ?? "AutoCompleteTransactionAmountFo",
    description:
      data?.description ?? "used for trade account auto transfer as of now",
    dataFormat: data?.dataFormat ?? "json",
    value: normalizeValue(data?.value),
  };
};

const currencyLabel = (currencyId: string | number) => {
  const key = Number(currencyId);
  return CurrencyTypes[key] || String(currencyId);
};

const normalizeType = (type: string) => String(type || "").toUpperCase();

const show = () => {
  dialogRef.value = true;
  fetchData();
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const response = await PaymentService.getAutoTransferOptions();
    formData.value = normalizeConfig(response);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const buildPayload = (): AutoCompleteTransferConfig => {
  // When sending back to API, convert displayed major-unit amounts back to cents (integer)
  const value = {
    ...formData.value.value,
    allowCurrencyTransfer: Object.fromEntries(
      Object.entries(formData.value.value.allowCurrencyTransfer || {}).map(
        ([currencyId, rules]: [string, any]) => {
          const mapped = (rules || []).map((rule: any) => ({
            ...rule,
            amount: Math.round((rule?.amount ?? 0) * 100),
          }));
          return [currencyId, mapped];
        }
      )
    ),
  };

  return {
    key: formData.value.key,
    name: formData.value.name,
    description: formData.value.description,
    dataFormat: formData.value.dataFormat,
    value,
  };
};

const updateAndRefresh = async () => {
  isLoading.value = true;
  try {
    await PaymentService.updateAutoTransferOptions(buildPayload());
    await fetchData();
  } catch (error) {
    MsgPrompt.error(error);
    isLoading.value = false;
  }
};

const onMainEnabledChange = async () => {
  await updateAndRefresh();
};

const onOverMarginCheckChange = async () => {
  await updateAndRefresh();
};

const onBetweenSwitchChange = async (key: string, enabled: boolean) => {
  formData.value.value.allowCurrencyBetween[key] = enabled;
  await updateAndRefresh();
};

const onTransferSwitchChange = async (
  currencyId: string,
  index: number,
  enabled: boolean
) => {
  const rules = formData.value.value.allowCurrencyTransfer[currencyId] || [];
  if (!rules[index]) return;
  rules[index].enabled = enabled;
  await updateAndRefresh();
};

const onAmountKeydown = (event: KeyboardEvent) => {
  const blockedKeys = [".", ",", "e", "E", "+", "-"];
  if (blockedKeys.includes(event.key)) {
    event.preventDefault();
  }
};

const onAmountChange = (currencyId: string, index: number, value: any) => {
  const rules = formData.value.value.allowCurrencyTransfer[currencyId] || [];
  if (!rules[index]) return;

  const nextValue = Number(value);
  if (!Number.isFinite(nextValue) || nextValue < 0) {
    rules[index].amount = 0;
    return;
  }

  rules[index].amount = Math.trunc(nextValue);
};

const submit = async () => {
  isLoading.value = true;
  try {
    await PaymentService.updateAutoTransferOptions(buildPayload());
    await fetchData();
    MsgPrompt.success(`${DIALOG_TITLE} ${i18n.global.t("status.updated")}`);
    dialogRef.value = false;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogRef).value = $event)),
    width: "760",
    "align-center": "",
    "close-on-click-modal": true
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("autoTransfer.title")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("status.enabled")), 1),
          _createVNode(_component_el_switch, {
            modelValue: formData.value.value.enabled,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.value.enabled) = $event)),
            disabled: isLoading.value,
            onChange: onMainEnabledChange
          }, null, 8, ["modelValue", "disabled"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass([
          'auto-transfer-content d-flex flex-column gap-4',
          { disabled: !formData.value.value.enabled },
        ])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("autoTransfer.disableTimeRangeUtc")), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_time_select, {
                  modelValue: formData.value.value.currencyTransferUnAvailableStartTime,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.value.currencyTransferUnAvailableStartTime) = $event)),
                  "max-time": formData.value.value.currencyTransferUnAvailableEndTime,
                  start: "00:00",
                  step: "00:01",
                  end: "23:59",
                  format: "HH:mm",
                  placeholder: "00:00",
                  style: {"width":"140px"},
                  disabled: isLoading.value || !formData.value.value.enabled
                }, null, 8, ["modelValue", "max-time", "disabled"]),
                _hoisted_11,
                _createVNode(_component_el_time_select, {
                  modelValue: formData.value.value.currencyTransferUnAvailableEndTime,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.value.currencyTransferUnAvailableEndTime) = $event)),
                  "min-time": formData.value.value.currencyTransferUnAvailableStartTime,
                  start: "00:00",
                  step: "00:01",
                  end: "23:59",
                  format: "HH:mm",
                  placeholder: "00:00",
                  style: {"width":"140px"},
                  disabled: isLoading.value || !formData.value.value.enabled
                }, null, 8, ["modelValue", "min-time", "disabled"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("autoTransfer.autoCompleteOverMarginCheck")), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(formData.value.value.autoCompleteOverMarginCheck
                    ? _ctx.$t("status.enabled")
                    : _ctx.$t("status.disabled")), 1),
                _createVNode(_component_el_switch, {
                  modelValue: formData.value.value.autoCompleteOverMarginCheck,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.value.autoCompleteOverMarginCheck) = $event)),
                  disabled: isLoading.value,
                  onChange: onOverMarginCheckChange
                }, null, 8, ["modelValue", "disabled"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("autoTransfer.allowBetween")), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              (allowCurrencyBetweenEntries.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowCurrencyBetweenEntries.value, (entry) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: entry.key,
                        class: "d-flex align-items-center justify-content-between border rounded p-3"
                      }, [
                        _createElementVNode("span", _hoisted_23, [
                          _createElementVNode("span", null, _toDisplayString(currencyLabel(entry.fromId)), 1),
                          _hoisted_24,
                          _createElementVNode("span", null, _toDisplayString(currencyLabel(entry.toId)), 1)
                        ]),
                        _createVNode(_component_el_switch, {
                          "model-value": entry.enabled,
                          disabled: isLoading.value || !formData.value.value.enabled,
                          onChange: (val) => onBetweenSwitchChange(entry.key, val as boolean)
                        }, null, 8, ["model-value", "disabled", "onChange"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t("tip.noData")), 1))
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("autoTransfer.allowTransfer")), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowCurrencyTransferEntries.value, (group) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: group.currencyId,
                  class: "border rounded p-3"
                }, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(currencyLabel(group.currencyId)), 1),
                  _createElementVNode("div", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.rules, (rule, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${group.currencyId}_${index}_${rule.type}`,
                        class: "d-flex align-items-center justify-content-between border rounded p-3"
                      }, [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_el_tag, { type: "info" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(normalizeType(rule.type)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("fields.amount")) + ":", 1),
                            _createVNode(_component_el_input_number, {
                              modelValue: rule.amount,
                              "onUpdate:modelValue": ($event: any) => ((rule.amount) = $event),
                              min: 0,
                              precision: 0,
                              step: 1,
                              "step-strictly": true,
                              disabled: isLoading.value || !formData.value.value.enabled,
                              "controls-position": "right",
                              onKeydown: onAmountKeydown,
                              onChange: 
                          (val) => onAmountChange(group.currencyId, index, val)
                        
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                          ])
                        ]),
                        _createVNode(_component_el_switch, {
                          "model-value": rule.enabled,
                          disabled: isLoading.value || !formData.value.value.enabled,
                          onChange: (val) => onTransferSwitchChange(group.currencyId, index, val as boolean)
                        }, null, 8, ["model-value", "disabled", "onChange"])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128)),
              (!allowCurrencyTransferEntries.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.$t("tip.nodata")), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (dialogRef.value = false)),
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submit,
            loading: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})